import post0 from './blogs/acf-flexible-content-sections-marketing-websites.json';
import post1 from './blogs/algolia-sitesearch360-fusejs-website-search.json';
import post2 from './blogs/calendly-hubspot-website-forms-lead-workflows.json';
import post3 from './blogs/connect-website-forms-salesforce-lead-data.json';
import post4 from './blogs/core-web-vitals-optimization-checklist.json';
import post5 from './blogs/crm-integration-mistakes-sales-reporting.json';
import post6 from './blogs/datalayer-gtm-form-conversion-tracking.json';
import post7 from './blogs/ecommerce-seo-checklist-woocommerce-magento.json';
import post8 from './blogs/fast-search-filter-large-content-websites.json';
import post9 from './blogs/formassembly-marketo-integration-lead-generation.json';
import post10 from './blogs/google-tag-manager-setup-checklist.json';
import post11 from './blogs/hotjar-clarity-ux-analytics-what-to-track.json';
import post12 from './blogs/improve-wordpress-performance-editorial-workflow.json';
import post13 from './blogs/magento-ecommerce-development-store-architecture.json';
import post14 from './blogs/marketplace-product-listing-seo-amazon-flipkart.json';
import post15 from './blogs/nextjs-web-applications-saas-product-teams.json';
import post16 from './blogs/onetrust-consent-mode-privacy-tracking.json';
import post17 from './blogs/react-vs-wordpress-seo.json';
import post18 from './blogs/roots-sage-wordpress-theme-development.json';
import post19 from './blogs/schema-markup-education-program-listings.json';
import post20 from './blogs/secure-wordpress-maintenance-checklist.json';
import post21 from './blogs/seo-friendly-landing-pages-service-businesses.json';
import post22 from './blogs/seo-strategy-program-course-campus-pages.json';
import post23 from './blogs/server-side-rendering-seo-react-nextjs.json';
import post24 from './blogs/sync-woocommerce-orders-customers-crm-inventory.json';
import post25 from './blogs/trustpilot-unibuddy-google-maps-website-widgets.json';
import post26 from './blogs/university-course-finder-seo.json';
import post27 from './blogs/woocommerce-checkout-flywire-invoicing.json';
import post28 from './blogs/woocommerce-crm-integration-guide.json';
import post29 from './blogs/wordpress-plugin-integrations-forms-crm-analytics.json';

const blogPosts = [post0, post1, post2, post3, post4, post5, post6, post7, post8, post9, post10, post11, post12, post13, post14, post15, post16, post17, post18, post19, post20, post21, post22, post23, post24, post25, post26, post27, post28, post29].sort((a, b) => new Date(b.date) - new Date(a.date));

export function getBlogPostBySlug(slug) {
  if (!slug) return null;
  return blogPosts.find((post) => post.slug === slug) || null;
}

export function getBlogPostById(id) {
  const numericId = Number(id);
  if (!Number.isFinite(numericId)) return null;
  return blogPosts.find((post) => post.id === numericId) || null;
}

export function getBlogPostBySlugOrId(param) {
  if (!param) return null;
  return getBlogPostBySlug(param) || getBlogPostById(param);
}

export function getFeaturedBlogPosts(limit = 10) {
  const featured = blogPosts.filter((post) => post.featured);
  const source = featured.length >= limit ? featured : blogPosts;
  return source.slice(0, limit);
}

export function getRelatedBlogPosts(post, limit = 3) {
  if (!post) return [];
  return blogPosts
    .filter(
      (candidate) =>
        candidate.id !== post.id &&
        (candidate.category === post.category ||
          candidate.homepageTheme === post.homepageTheme)
    )
    .slice(0, limit);
}

export function getAllBlogSlugs() {
  return blogPosts.map((post) => post.slug);
}

export { blogPosts };
export default blogPosts;
